import * as http from 'axios'

export const listProfissionais = (idRede) => http.get(`redes/${idRede}/corpoClinico`)
export const listProfissionaisAtivos = (idRede) => http.get(`redes/${idRede}/corpoClinico?status=ATIVO`)
export const saveCorpoClinico = (payload) => http.post('/corpoClinico', payload)
export const remove = (idCorpoClinico) => http.delete(`/corpoClinico/${idCorpoClinico}`)
export const get = (idCorpoClinico) => http.get(`/corpoClinico/${idCorpoClinico}?populate=especialidade`)
export const update = (idCorpoClinico, payload) => http.put(`/corpoClinico/${idCorpoClinico}`, payload)

export const getAgendaPorProfissional = (idCorpoClinico) => http.get(`/agenda?corpo_clinico=${idCorpoClinico}&sort=dia_semana.key`)
export const saveAgenda = (payload) => http.post('/agenda', payload)
export const removeAgenda = (idAgenda) => http.delete(`/agenda/${idAgenda}`)
export const findProfissionalByRede = (idRede, search) => http.get(`/corpoClinico?rede=${idRede}&nome__regex=/.*${search}.*/i&populate=especialidade`)



// WEBPACK FOOTER //
// ./src/store/corpoClinico/services.js